/**
 * The words a suggested mention is said in, around the elements it names, phrased as what the
 * rule wants: "Names X without a mention", "Describes X without a mention", "Should mention X".
 */
export function suggestedMentionWords(frame) {
    switch (frame) {
        case "mention_named":
            return { before: "Names ", after: " without a mention" };
        case "mention_described":
            return { before: "Describes ", after: " without a mention" };
        case "mention_required":
            return { before: "Should mention ", after: "" };
    }
}
/** "a Dataset", "an Agent". */
function withArticle(label) {
    return `${/^[aeiou]/i.test(label) ? "an" : "a"} ${label}`;
}
/** Items joined as people read a list: "A", "A and B", "A, B and C". */
export function joinedForReading(items) {
    if (items.length <= 1)
        return items[0] ?? "";
    return `${items.slice(0, -1).join(", ")} and ${items.at(-1)}`;
}
/**
 * What a suggested mention names, in reading order: its live elements' names; for a required
 * mention that names none, the types it reaches ("a Dataset or a Field").
 */
export function suggestedMentionTargets(mention) {
    const named = mention.elements.map((element) => element.name);
    if (named.length > 0)
        return named;
    if (mention.frame === "mention_required" && mention.typeLabels.length > 0) {
        return [mention.typeLabels.map(withArticle).join(" or ")];
    }
    return [];
}
/** The whole sentence in plain text, for a reader that shows no links. */
export function suggestedMentionSentence(mention) {
    const targets = suggestedMentionTargets(mention);
    if (targets.length === 0)
        return null;
    const { before, after } = suggestedMentionWords(mention.frame);
    return `${before}${joinedForReading(targets)}${after}.`;
}
